export class Eixo {
    id: number;
    nome: string;
    descricao: string;
}
